import { ActionIcon, Flex } from '@mantine/core';
import { IconEye, IconTrash } from '@tabler/icons-react';
import { MouseEventHandler } from 'react';

export const CellShowDeleteAction = (props: {
	onShow: MouseEventHandler<HTMLButtonElement>;
	onDelete: MouseEventHandler<HTMLButtonElement>;
	data: any;
}) => {
	const { onShow, onDelete } = props;
	return (
		<Flex gap="10px" justify={'flex-end'}>
			<ActionIcon
				h={'30px'}
				w={'30px'}
				variant="filled"
				radius={'xl'}
				color={'#DDF9ED'}
				onClick={onShow}
			>
				<IconEye
					color="#2C8C5E"
					size="18px"
					stroke={1.5}
				/>
			</ActionIcon>
			<ActionIcon
				h={'30px'}
				w={'30px'}
				variant="filled"
				radius={'xl'}
				color={'rgba(254, 229, 235, 0.60)'}
				onClick={onDelete}
			>
				<IconTrash
					color="#FF381C"
					size="18px"
					stroke={1.5}
				/>
			</ActionIcon>
		</Flex>
	);
};
